import classNames from 'classnames';

export default function QuantitySelector({
  quantity,
  setQuantity,
}: {
  quantity: number;
  setQuantity: React.Dispatch<React.SetStateAction<number>>;
}) {
  const handleDecrease = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  return (
    <div
      className={classNames(
        'mt-2',
        'flex',
        'items-center',
        'overflow-auto',
        'rounded',
        'border',
        'border-gray-300',
      )}
    >
      <button
        aria-label="Decrease quantity"
        data-testid="product-popup-decrease"
        className={classNames(
          'disabled:pointer-events-all',
          'p-2',
          'disabled:cursor-wait',
        )}
        onClick={handleDecrease}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('h-5', 'w-5', 'text-gray-400')}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
            clipRule="evenodd"
          ></path>
        </svg>
      </button>
      <div
        className={classNames('p-2', 'text-center', 'text-xs', 'text-gray-900')}
      >
        {quantity}
      </div>
      <button
        aria-label="Increase quantity"
        data-testid="product-popup-increase"
        className={classNames(
          'disabled:pointer-events-all',
          'p-2',
          'text-gray-400',
          'disabled:cursor-wait',
        )}
        onClick={() => setQuantity(quantity + 1)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('h-5', 'w-5')}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
            clipRule="evenodd"
          ></path>
        </svg>
      </button>
    </div>
  );
}
